module.exports = __webpack_public_path__ + "img/instagram-logo.a2d322fa.svg";